class StickyTitle {
  public element: HTMLElement | null;

  bindings() {
    if (this.element) {
      let distanceTop = this.element.getBoundingClientRect().top;
      let yPosOnSite = distanceTop + window.scrollY;

      window.addEventListener('scroll', () => {
        if (distanceTop < 100 && this.element) {
          distanceTop = this.element.getBoundingClientRect().top;
        } else {
          if (this.element && window.scrollY + 100 > yPosOnSite && window.innerWidth >= 1024) {
            this.element.style.position = 'fixed';
            this.element.style.top = '100px';
            this.element.classList.add('fixed');
          } else if (this.element) {
            this.element.style.position = 'relative';
            this.element.style.top = 'auto';
            this.element.classList.remove('fixed');
          }
        }
      });

      window.addEventListener('resize', () => {
        if (this.element && window.innerWidth < 1024) {
          this.element.style.position = 'relative';
          this.element.style.top = 'auto';
          this.element.classList.remove('fixed');
        }
      });
    }
  }

  cache() {
    this.element = document.querySelector('.o-hero-product__titles');
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default StickyTitle;
